import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import backend from "../../../api";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../common/breadcrumb";
import ConnectComponent from "../../common/stripe/ConnectComponent";
import EmoneyDetails from "./components/EmoneyDetails";

const ViewAccount = () => {
  const { accountType, accountId, id } = useParams();
  const [accountDetails, setAccountDetails] = useState({});
  const [bankingDetails, setBankingDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getDetails = async (accountId, id) => {
    setIsLoading(true);
    try {
      const endPoint =
        accountType === "e-money"
          ? `/auth/user-by-bank?bankAccount=${accountId}`
          : `/connected-account/details/${accountId}`;

      const [accountResponse, bankResponse] = await Promise.all([
        backend.get(`/accounts/${id}`),
        backend.get(endPoint),
      ]);

      console.log("accountResponse: ", accountResponse);
      console.log("bankResponse: ", bankResponse);

      const { account } = accountResponse?.data;
      const { user } = bankResponse?.data;

      setAccountDetails(account);
      setBankingDetails(user);
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDetails(accountId, id);
  }, [accountId, id]);

  return (
    <div>
      <Helmet>
        <title>eksplode! | Payment Integration</title>
      </Helmet>
      <Breadcrumb title={"View Account"} />

      <section className="about-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="box-head">
                <div className="d-flex justify-content-between">
                  <h2 className="text-dark">Account Detail</h2>
                  <Link
                    to={`/account-list?accountType=${accountType}`}
                    className="btn btn-solid mt-2"
                  >
                    My Accounts
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-sm-12">
              {accountType === "e-money" ? (
                <EmoneyDetails accountDetails={accountDetails} />
              ) : (
                <div>
                  <ConnectComponent
                    accountId={accountId}
                    accountDetails={accountDetails}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewAccount;
